var _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon4, _polygon5, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLesMateriaux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 462.33 127.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "57.76 22.53 19.3 45.07 19.3 22.14 58.53 0 97.38 23.31 97.38 45.07 57.76 22.53 57.76 22.53",
    fill: "#e30613"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "56.98 116.16 38.33 127.82 0 104.51 0 58.21 18.2 48.63 18.2 94.02 56.98 116.16 56.98 116.16",
    fill: "#e30613"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "60.22 116.16 78.87 127.82 117.2 104.51 117.2 58.21 99 48.63 99 94.02 60.22 116.16 60.22 116.16",
    fill: "#e30613"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.82,48.31h23.67l5.44,22.82h.12l5.38-22.83H184V90H169.69l-.24-32.75h-.12L161.14,90H147.82l-7.95-32.75h-.25L139.44,90H125.82Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.52,60a40.07,40.07,0,0,1,13-1.8c8.63,0,19.1,1.56,19.1,13V90h-14V85.55h-.12c-2.1,3.52-5.92,5.2-10.16,5.2-5.8,0-11.42-2.63-11.42-9.15,0-9.56,8.61-11.47,16.08-11.47,2.09,0,4.48.3,5.85.42-.06-4-4.18-4.49-7.94-4.49a24.3,24.3,0,0,0-10.4,2.63Zm18.34,16.37h-1.49c-3.11,0-6.69.3-6.69,3.53,0,2.15,1.19,3,3.52,3,3.11,0,4.66-2.87,4.66-5.56Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.09,58.89V51.72l15.06-4.6V58.89H253v9h-6.81v8.78c0,2.63,1.31,4.07,3.28,4.07A10.59,10.59,0,0,0,253,80.2v9a36.23,36.23,0,0,1-10.34,1.55c-7.77,0-11.53-3.89-11.53-12.14V67.86h-5.32v-9Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.53,45.2l-11.77,9.33h-8.31l5.92-9.33Zm-8.48,26.3c0-2.39-.36-6.15-3.77-6.15s-4.24,3.7-4.06,6.15Zm-7.77,6.63c.24,3.88,3.88,4.78,8.3,4.78a23.19,23.19,0,0,0,10.22-2V89a47.65,47.65,0,0,1-14,1.8c-12.61,0-19.31-6.1-19.31-16.86,0-10.46,6.7-15.72,19.31-15.72,12.07,0,16.32,7.53,16.32,18v1.94Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M308.18,58.89v7h.12c1.8-4.42,4.78-7.77,9.51-7.77a9.19,9.19,0,0,1,2.45.3V71a10.38,10.38,0,0,0-3.41-.47,8,8,0,0,0-7.71,8.24V90H294.08V58.89Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M324,58.89H339V90H324ZM339,55.6H324V45.2H339Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M346.49,60a40.07,40.07,0,0,1,13-1.8c8.64,0,19.13,1.56,19.13,13V90h-14V85.55h-.12c-2.09,3.52-5.91,5.2-10.16,5.2-5.8,0-11.41-2.63-11.41-9.15,0-9.56,8.6-11.47,16.07-11.47,2.1,0,4.49.3,5.86.42-.06-4-4.18-4.49-8-4.49a24.44,24.44,0,0,0-10.4,2.63Zm18.35,16.37h-1.49c-3.11,0-6.7.3-6.7,3.53,0,2.15,1.2,3,3.53,3,3.11,0,4.66-2.87,4.66-5.56Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M418.94,90H404.71V84.65h-.09c-1.79,4.36-5.92,6.1-10.16,6.1-8,0-10.94-4.19-10.94-10.22V58.89h15.06V76.82c0,1.79,0,4.25,2.63,4.25s2.69-2.46,2.69-4.25V58.89H419Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M437.52,58.89l4.18,9.33,4.19-9.33h14.73L452,73.06l10.28,17H446.31l-4.91-10-5.08,10H421l10.22-16.73-9.5-14.41Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.62,15.63h11.26V36.29h13.81v8.65H108.62Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.67,36.54c.17,2.73,2.73,3.36,5.84,3.36a16.26,16.26,0,0,0,7.18-1.38v5.66a33.28,33.28,0,0,1-9.87,1.26c-8.86,0-13.56-4.28-13.56-11.84,0-7.35,4.7-11,13.56-11,8.49,0,11.47,5.29,11.47,12.68v1.3Zm5.46-4.62c0-1.68-.25-4.32-2.64-4.32s-3,2.6-2.86,4.32Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.34,37.93a16,16,0,0,0,7.77,2c1.77,0,3.87-.33,3.87-1.43,0-2.68-12.27-.08-12.27-8.52,0-6.3,7.1-7.39,12.31-7.39a39.53,39.53,0,0,1,7.89.92v5.88A21.25,21.25,0,0,0,175,28.13c-1.81,0-3.66.17-3.66,1.51,0,2.27,12.26-.33,12.26,7.9,0,6.25-7.13,7.93-12.13,7.93a37.32,37.32,0,0,1-9.16-1.26Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.38 102.37 79.38 81.2 95.7 71.1 95.7 50.12 59.96 70.71 59.96 113.44 79.38 102.37 79.38 102.37",
    fill: "#004380"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "38.2 102.24 38.2 81.2 21.89 71.1 21.89 50.12 57.63 70.71 57.63 113.44 38.2 102.24 38.2 102.24",
    fill: "#004380"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.29,63.19A14.87,14.87,0,1,0,44.43,48.31h0A14.87,14.87,0,0,0,59.29,63.19Z",
    transform: "translate(0 0)",
    fill: "#004380"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.52,99.77h7c6.67,0,11.33,2.31,11.33,10.55,0,8-4.8,10.74-11.33,10.74h-7Zm5.1,17.08h2c3.81,0,5.95-2.2,5.95-6.44s-2.22-6.43-5.95-6.43h-2Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.94,114.71c.28,2.2,1.79,3.05,4.2,3.05a8.43,8.43,0,0,0,4.37-1.22v3.88a13.07,13.07,0,0,1-5.24,1c-4.73,0-8.32-3.08-8.32-8.32s3.21-8.3,7.66-8.3c5.3,0,7.22,4.18,7.22,8.91v1Zm5.44-3.11c0-1.83-.77-3.32-2.75-3.32-1.78,0-2.63,1.49-2.74,3.32Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.13,116.66a11.29,11.29,0,0,0,4.64,1.1c1,0,2-.18,2-1.28,0-2.68-7-.79-7-6.53,0-3.66,3.24-5.15,6.09-5.15a12.26,12.26,0,0,1,5,.91l-.39,3.82a7.44,7.44,0,0,0-3.84-1.07c-1.07,0-2.28.21-2.28,1.1,0,2.47,7.36.52,7.36,6.56,0,4.24-3.43,5.3-6.67,5.3a14.76,14.76,0,0,1-5.19-.76Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.43,105.13H190V108H190a5.52,5.52,0,0,1,5.32-3.23c4,0,6.12,4.18,6.12,8,0,4.7-2.27,8.6-6.53,8.6a4.85,4.85,0,0,1-4.53-2.59h0v8.63h-4.94Zm8,3.84c-1.81,0-3,1.77-3,4.15s1.37,4,3,4c1.86,0,3-1.74,3-4.27-.05-2.06-1.12-3.89-3-3.89Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.09,109.56a5,5,0,0,0-1.68-.19c-2.3,0-3.59,1.87-3.59,5v6.71h-4.95v-16h4.51v3h.05c.85-2,2.09-3.29,4.23-3.29a9.38,9.38,0,0,1,1.67.18Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M214.89,113.13c0-5.28,3.59-8.33,8.32-8.33s8.31,3,8.31,8.33-3.59,8.29-8.31,8.29S214.89,118.37,214.89,113.13Zm11.53,0c0-2.38-.94-4.49-3.21-4.49s-3.22,2.11-3.22,4.49.94,4.45,3.22,4.45S226.42,115.47,226.42,113.13Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M231.8,124.13a4.19,4.19,0,0,0,1,.09c1.54,0,1.65-1.59,1.65-3.11v-16h4.94v16c0,4-1.15,6.62-5,6.62a11.24,11.24,0,0,1-2.77-.28Zm7.63-21.51h-4.94v-4h4.94Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M247.39,114.71c.28,2.2,1.79,3.05,4.2,3.05a8.43,8.43,0,0,0,4.37-1.22v3.88a13.12,13.12,0,0,1-5.25,1c-4.72,0-8.31-3.08-8.31-8.32s3.21-8.3,7.66-8.3c5.29,0,7.21,4.18,7.21,8.91v1Zm5.44-3.11c0-1.83-.77-3.32-2.75-3.32-1.78,0-2.63,1.49-2.74,3.32Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M258.62,105.13h2.91v-3.57l4.86-1.68v5.25h3.46V109h-3.46v5.85c0,1.93.41,2.9,2,2.9a9.63,9.63,0,0,0,1.51-.21l.16,3.57a22.91,22.91,0,0,1-3.1.3c-4.42,0-5.49-2.16-5.49-6v-6.46h-2.85Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M271.77,116.66a11.13,11.13,0,0,0,4.64,1.1c1,0,2-.18,2-1.28,0-2.68-7-.79-7-6.53,0-3.66,3.24-5.15,6.09-5.15a12.26,12.26,0,0,1,5,.91l-.38,3.82a7.44,7.44,0,0,0-3.84-1.07c-1.07,0-2.28.21-2.28,1.1,0,2.47,7.36.52,7.36,6.56,0,4.24-3.44,5.3-6.67,5.3a14.76,14.76,0,0,1-5.19-.76Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M294.06,105.13h4.56V108h.05a5.54,5.54,0,0,1,5.33-3.23c3.95,0,6.12,4.18,6.12,8,0,4.7-2.28,8.6-6.53,8.6a4.83,4.83,0,0,1-4.53-2.59H299v8.63h-4.94Zm8,3.84c-1.81,0-3,1.77-3,4.15s1.38,4,3,4c1.87,0,3-1.74,3-4.27,0-2.06-1.11-3.89-3-3.89Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M311.83,113.13c0-5.28,3.59-8.33,8.31-8.33s8.32,3,8.32,8.33-3.6,8.29-8.32,8.29S311.83,118.37,311.83,113.13Zm11.52,0c0-2.38-.93-4.49-3.21-4.49s-3.21,2.11-3.21,4.49.93,4.45,3.21,4.45,3.21-2.11,3.21-4.45Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M346.09,121.06h-4.47v-2.93h0a5.35,5.35,0,0,1-5.22,3.29c-3.9,0-5.46-3-5.46-6.34v-10h4.94v7.68c0,3,.94,4,2.28,4,2,0,3.07-1.56,3.07-5v-6.68h5Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M359.37,109.56a5,5,0,0,0-1.67-.19c-2.31,0-3.6,1.87-3.6,5v6.71h-4.94v-16h4.46v3h.06c.85-2,2.09-3.29,4.23-3.29a9.38,9.38,0,0,1,1.67.18Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M370.33,98.18h4.94v22.88h-4.94Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M388.28,121.06c0-.86-.11-1.68-.11-2.5h-.05a4.83,4.83,0,0,1-4.53,2.86c-2.83,0-5.36-1.55-5.36-5,0-4.85,4.75-5.43,7.39-5.43a12.7,12.7,0,0,1,2.3.21c0-2.16-1.48-2.74-3.26-2.74a8.6,8.6,0,0,0-4.56,1.19l-.08-3.72a13.37,13.37,0,0,1,5.71-1.13c3.65,0,6.81,1.74,6.81,6.59v5.91a21.49,21.49,0,0,0,.27,3.76Zm-3.4-3.3c1.86,0,3-1.89,3-3.75-.63,0-1.34-.09-2.08-.09-1.68,0-3,.58-3,2.1a1.78,1.78,0,0,0,1.82,1.76Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M402.83,105.13h5.3l3,11.31h.06l3-11.31h4.91L413.81,121h-5.63Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M426.38,102.57h-4.94v-4h4.94Zm-4.94,2.6h4.94v15.89h-4.94Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M434.35,114.71c.27,2.2,1.78,3.05,4.2,3.05a8.39,8.39,0,0,0,4.36-1.22v3.88a13.07,13.07,0,0,1-5.24,1c-4.72,0-8.32-3.08-8.32-8.32s3.21-8.3,7.66-8.3c5.3,0,7.22,4.18,7.22,8.91v1Zm5.43-3.11c0-1.83-.77-3.32-2.74-3.32-1.79,0-2.64,1.49-2.75,3.32Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M461.62,113.83h-3.68l-.72-14.06h5.11Zm-4.16,2.3h4.61v4.94h-4.61Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesMateriaux);
export default __webpack_public_path__ + "static/media/les-materiaux.e175d1c7.svg";
export { ForwardRef as ReactComponent };